import { defineNuxtPlugin, hasSessionCookie, markBfcacheAuthReload, useUserInfo } from '#imports'

export default defineNuxtPlugin({
    name: 'bfcache-reload',
    setup() {
        const userInfo = useUserInfo()

        window.addEventListener('pageshow', (event) => {
            if (!event.persisted) return

            if (hasSessionCookie() !== userInfo.isLoggedIn.value) {
                markBfcacheAuthReload()
                window.location.reload()
            }
        })
    },
})
